import Vue from "vue";
import Router from "vue-router";

import AccountView from './views/account/Account';
import AccountPassword from './views/account/Password';

import ConnectionIndex from './views/connections/Index.vue';
import ConnectionView from './views/connections/View.vue'
import ConnectionCreate from './views/connections/Create.vue';

import OrganizationIndex from './views/organizations/Index.vue';
import OrganizationCreate from './views/organizations/Create.vue';
import OrganizationUsers from './views/organizations/users/Index.vue';
import OrganizationUsersCreate from './views/organizations/users/Create.vue';

import QueryIndex from './views/queries/Index.vue';
import QueryCreate from './views/queries/Header.vue';
import QueryHistory from './views/queries/History.vue';
import QueryVisualizations from './views/queries/Visualizations.vue';

import ReportIndex from './views/reports/Index.vue';
import ReportCreate from './views/reports/Create.vue';
import ReportShow from './views/reports/Show.vue';
import ReportEmbed from './views/reports/embed/Embed.vue';

import Login from './components/Login.vue';
import Register from './components/Register.vue';
import RecoverPassword from './components/RecoverPassword.vue';
import ResetPassword from './components/ResetPassword.vue';
import Welcome from './components/Welcome.vue';
import ActiveAccount from './components/ActivateAccount';

import VisualizationIndex from './views/visualizations/Index.vue';
import VisualizationCreate from './views/visualizations/Create.vue';
import VisualizationShow from './views/visualizations/Show.vue';
import VisualizationEmbed from './views/visualizations/Embed.vue';
import VisualizationMain from './views/visualizations/Main.vue';

Vue.use(Router);

const primaryTitle = 'Data Providers';

export default new Router({
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: Welcome,
      meta: {
          auth: true,
          title: primaryTitle,
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
          auth: false,
          title: `Register - ${primaryTitle}`,
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      props: (route) => ({
          report_id: route.query.report_id
      }),
      meta: {
          auth: false,
          title: `Login - ${primaryTitle}`,
      }
    },
    {
        path: '/password/recover',
        name: 'password.recover',
        component: RecoverPassword,
        meta: {
            auth: false,
            title: `Recover Password - ${primaryTitle}`,
        }
    },
    {
        path: '/users/password/reset/:token',
        props: true,
        name: 'password.reset',
        component: ResetPassword,
        meta: {
            auth: false,
            title: `Reset Password - ${primaryTitle}`,
        }
    },
    {
        path: '/users/activate/:user_id/:mail_token',
        props: true,
        name: 'account.activate',
        component: ActiveAccount,
        meta: {
            title: primaryTitle,
        }
    },
    {
        path: '/account/activate/:user_id/:mail_token',
        props: true,
        name: 'account.email.activate.guest',
        component: Login,
        meta: {
            auth: false,
            title: primaryTitle,
        }
    },
    {
        path: '/account',
        name: 'account',
        component: AccountView,
        meta: {
            auth: true,
            title: `Account - ${primaryTitle}`,
        }
    },
    {
        path: '/account/activate/:user_id/:mail_token',
        props: true,
        name: 'account.email.activate.logged',
        component: AccountView,
        meta: {
            auth: true,
            title: primaryTitle,
        }
    },
    {
        path: '/account/password',
        name: 'account.password',
        component: AccountPassword,
        meta: {
            auth: true,
            title: `Change Password - ${primaryTitle}`,
        }
    },
    {
        path: '/connection',
        name: 'connection',
        component: ConnectionIndex,
        meta: {
            auth: true,
            title: `Connections - ${primaryTitle}`,
        }
    },
    {
        path: '/connection/create',
        name: 'connection.create',
        component: ConnectionCreate,
        meta: {
            auth: true,
            title: `Create Connection - ${primaryTitle}`,
        }
    },
    {
        path: '/connection/:connectionId',
        name: 'connection.view',
        component: ConnectionView,
        props: true,
        meta: {
            auth: true,
            title: `View Connection - ${primaryTitle}`,
        }
    },
    {
        path: '/connection/:connectionId/edit',
        name: 'connection.edit',
        component: ConnectionCreate,
        meta: {
            auth: true,
            title: `Edit Connection - ${primaryTitle}`,
        }
    },
    {
        path: '/organization',
        name: 'organization',
        component: OrganizationIndex,
        meta: {
            auth: true,
            title: `Organizations - ${primaryTitle}`,
        }
    },
    {
        path: '/organization/create',
        name: 'organization.create',
        component: OrganizationCreate,
        meta: {
            auth: true,
            title: `Create Organization - ${primaryTitle}`,
        }
    },
    {
        path: '/organization/:organization_id/edit',
        name: 'organization.edit',
        component: OrganizationCreate,
        props: true,
        meta: {
            auth: true,
            title: `Edit Organization - ${primaryTitle}`,
        }
    },
    {
        path: '/organization/:organization_id/users',
        name: 'organization.users',
        component: OrganizationUsers,
        props: true,
        meta: {
            auth: true,
            title: `Users in Organization - ${primaryTitle}`,
        }
    },
    {
        path: '/organization/:organization_id/users/create',
        name: 'organization.users.create',
        component: OrganizationUsersCreate,
        props: true,
        meta: {
            auth: true,
            title: `Users in Organization - ${primaryTitle}`,
        }
    },
    {
        path: '/query',
        name: 'query',
        component: QueryIndex,
        meta: {
            auth: true,
            title: `Queries - ${primaryTitle}`,
        }
    },
    {
        path: '/query/:query_id/edit',
        name: 'query.edit',
        component: QueryCreate,
        props: true,
        meta: {
            auth: true,
            title: `Edit Query - ${primaryTitle}`,
        }
    },
    {
        path: '/query/create',
        name: 'query.create',
        component: QueryCreate,
        meta: {
            auth: true,
            title: `Create Query - ${primaryTitle}`,
        }
    },
    {
        path: '/query/:query_id/history',
        name: 'query.history',
        component: QueryHistory,
        props: true,
        meta: {
            auth: true,
            title: `Query - ${primaryTitle}`,
        }
    },
    {
        path: '/query/:query_id/visualizations',
        name: 'query.visualizations',
        component: QueryVisualizations,
        props: true,
        meta: {
            auth: true,
            title: `Query - ${primaryTitle}`,
        }
    },
    {
        path: '/visualizaton/main',
        name: 'visualization.main',
        component: VisualizationMain,
        meta: {
            auth: true,
            title: `Visualizations - ${primaryTitle}`,
        }
    },
    {
        path: '/visualization/create',
        name: 'visualization.create',
        component: VisualizationCreate,
        props: true,
        meta: {
            auth: true,
            title: `Create Visualization - ${primaryTitle}`,
        }
    },
    {
        path: '/visualization/:visualization_id/edit',
        name: 'visualization.edit',
        component: VisualizationCreate,
        props: true,
        meta: {
            auth: true,
            title: `Edit Visualization - ${primaryTitle}`,
        }
    },
    {
        path: '/visualization/:visualization_id',
        name: 'visualization.show',
        component: VisualizationShow,
        props: true,
        meta: {
            title: `View Visualization - ${primaryTitle}`,
        }
    },
    {
        path: '/visualization/embed/:visualization_id',
        name: 'visualization.embed',
        component: VisualizationEmbed,
        props: true,
        meta: {
            title: primaryTitle,
        }
    },
    {
        path: '/visualization',
        name: 'visualization',
        component: VisualizationIndex,
        meta: {
            auth: true,
            title: `Visualizations - ${primaryTitle}`,
        }
    },
    {
        path: '/report',
        name: 'report',
        component: ReportIndex,
        meta: {
            auth: true,
            title: `Reports - ${primaryTitle}`,
        }
    },
    {
        path: '/report/create',
        name: 'report.create',
        component: ReportCreate,
        props: true,
        meta: {
            auth: true,
            title: `Create Report - ${primaryTitle}`,
        }
    },
    {
        path: '/report/:report_id/edit',
        name: 'report.edit',
        component: ReportCreate,
        props: true,
        meta: {
            auth: true,
            title: `Edit Report - ${primaryTitle}`,
        }
    },
    {
        path: '/report/:report_id',
        name: 'report.show',
        component: ReportShow,
        props: true,
        meta: {
            title: `View Report - ${primaryTitle}`,
        }
    },
    {
        path: '/report/embed/:report_id',
        name: 'report.embed',
        component: ReportEmbed,
        props: true,
        meta: {
            title: primaryTitle,
        }
    }
  ]
});
